<span>{{startCount > 0 ? startCount : 0}} - {{endCount || 0}} of {{totalRecords || 0}} Results</span>
